import { useCallback } from 'react';

import { post, put } from '../../api';
import { useGlobalStore } from '../state/globalStore';
import { ENTITY_TO_PATH_MAP, ENTITY_TYPE } from '../utils/constants';
import { getEntityCookiePassword } from '../utils/helper';
import { reportErrorToPlayer } from '../utils/player-controller';
import { ERROR_CODES } from '../utils/player-controller/constants';

export const useLead = () => {
  const entityId = useGlobalStore((store) => store.apiEntityId);
  const entityType = useGlobalStore((store) => store.entityType);

  /*
   * This function is used to register the user for the entity type video,but can be used for any entity type
   */
  const putEntityEventLead = useCallback(
    async (payload: unknown, queryParams?: { [key: string]: string | undefined }) => {
      if (!entityType) return;
      try {
        const entityPassword = getEntityCookiePassword(entityId, entityType);
        const queryString = new URLSearchParams(
          Object.fromEntries(
            Object.entries({
              ...queryParams,
              password: entityPassword,
              is_embed: 'true',
            }).filter(([_, value]) => value !== undefined),
          ),
        ).toString();
        const url = `/lead_capture/${ENTITY_TO_PATH_MAP[entityType]}/${entityId}/registrants${
          queryString ? `?${queryString}` : ''
        }`;
        const data = await put(url, payload);
        return {
          success: true,
          data,
        };
      } catch (error) {
        if (entityType !== ENTITY_TYPE.EVENT) {
          reportErrorToPlayer({
            code: ERROR_CODES.ERROR_UPDATING_LEAD,
            message: 'Error in updating the lead.',
          });
        }
        return { success: false, error };
      }
    },
    [entityId, entityType],
  );

  /*
   * This function is used to login the user for the entity type video,but can be used for any entity type
   */
  const loginEntityLead = useCallback(
    async (payload: unknown) => {
      if (!entityType) return;
      try {
        const entityPassword = getEntityCookiePassword(entityId, entityType);
        const queryString = new URLSearchParams(
          Object.fromEntries(
            Object.entries({
              password: entityPassword,
              is_embed: 'true',
            }).filter(([_, value]) => value !== undefined),
          ),
        ).toString();
        return await post(
          `/lead_capture/${ENTITY_TO_PATH_MAP[entityType]}/${entityId}/login${
            queryString ? `?${queryString}` : ''
          }`,
          payload,
        );
      } catch (error) {
        if (entityType !== ENTITY_TYPE.EVENT) {
          reportErrorToPlayer({
            code: ERROR_CODES.LEAD_LOGIN_ERROR,
            message: 'Error while trying to login the lead.',
          });
        }
        return error;
      }
    },
    [entityId, entityType],
  );

  return {
    putEntityEventLead,
    loginEntityLead,
  };
};
